import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {TeamsRequestsService} from "./teams-requests.service";
import {TeamsAlertsService} from "./teams-alerts.service";
import {TeamModel} from "../models/team.model";

export class TeamsService {

  constructor(private teamsRequestsService: TeamsRequestsService, private teamsAlertsService: TeamsAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log, private $q) {
  }

  createTeam(team: TeamModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.teamsRequestsService.createTeam(team)
      .then((group) => {
        this.teamsAlertsService.createSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.teamsAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editTeam(team: TeamModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.teamsRequestsService.editTeam(team)
      .then((group) => {
        this.teamsAlertsService.editSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.teamsAlertsService.editError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteTeam(teamId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.teamsRequestsService.deleteTeam(teamId)
      .then((group) => {
        this.teamsAlertsService.deleteSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.teamsAlertsService.deleteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getTeamsAgentIds(teamIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.teamsRequestsService.getTeamsAgentIds(teamIds)
      .then((group) => {
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


  updateTeamAdmins(team: TeamModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.teamsRequestsService.updateTeamAdmins(team)
      .then((group) => {
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.teams')
  .service('teamsService', TeamsService);
